/* eslint-disable no-unused-expressions */
import React, { useMemo, useImperativeHandle, useEffect } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';
import { Form } from '@whalecloud/fdx';
import { renderFormItems, getAddrName } from '@/utils';
import { custOrderAttrFormItems } from './utils';

const CustomerOfferAttributes = props => {
  const {
    modelKey, custId, isTransferShift, custOrderAttrList,
    custAddrList, isNewAcctAddr, transferAddress, refInstance, form, dispatch,
  } = props;
  const { getFieldDecorator, getFieldValue, validateFields, resetFields, setFieldsValue } = form;

  useEffect(() => {
    if (modelKey === 'shift' || isTransferShift) {
      dispatch({
        type: 'business/qryCustAddrList',
        payload: {
          custId,
          addressTypeFlag: '2',
        },
        modelName: modelKey,
      });
    }
  }, [modelKey]);
  
  useImperativeHandle(refInstance, () => ({
    getAttributeInfo: async() => {
      const result = await validateFields();
      const attrList = [];
      Object.keys(result).forEach(key => {
        if (result[key] && !key.includes('empty')) {
          attrList.push({
            attrCode: key,
            value: result[key],
            attrValue: result[key],
          });
        }
      });
      return attrList;
    },
  }));

  const handleNeedAddressChange = value => {
    if (value === 'N') {
      resetFields('BSNL_SHIFT_BILLING_ADDRESS');
    } else { // 2867528 shift，billing address使用新安装地址，选择Yes时，自动带入地址信息
      modelKey === 'shift' && setFieldsValue({ BSNL_SHIFT_BILLING_ADDRESS: transferAddress?.selectAddress });
    }
  };

  const custOrderAttrItems = useMemo(() => custOrderAttrFormItems({
    modelKey,
    transferAddress,
    isTransferShift,
    isNewAcctAddr,
    defaultInfo: custOrderAttrList || [],
    custAddrList: custAddrList.map(addr => ({
      ...addr,
      labelValue: getAddrName(addr),
    })),
    needChangeAddress: getFieldValue('BSNL_UPDATE_BILLING_ADDRESS') === 'Y',
    onNeedAddressChange: handleNeedAddressChange,
  }), [modelKey, isTransferShift, getFieldValue('BSNL_UPDATE_BILLING_ADDRESS'), custAddrList, transferAddress]);

  if (isEmpty(custOrderAttrItems)) {
    return '';
  }

  return (
    <Form layout="inline">
      <div className="blockWrap">
        <h3 className="blockTitle">{i18n('CUST_ORDER_ATTR')}</h3>
        <div className="formItemBox">
          {renderFormItems(custOrderAttrItems, getFieldDecorator)}
        </div>
      </div>
    </Form>
  );
};

const Component = connect((state, { modelKey }) => ({
  custAddrList: state[modelKey].custAddrList || [],
  isNewAcctAddr: state[modelKey].isNewAcctAddr,
  transferAddress: state[modelKey].transferAddress || {},
}))(Form.create({ name: 'attribute.custOrder' })(CustomerOfferAttributes));
export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
